<template>
    <!--
        作者：kmdshop
        时间：2020-06-01
        描述：插件中心-现有库存-修改
      -->
      <el-dialog
      title="选择可查看的供应商"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
      style="margin-top: -130px;"
    >
  
    <div class="product-add">
      <div class="min-h-screen bg-gray-50 py-8">
    <div class="mx-auto w-[1440px]">
      <!-- 搜索区域 -->
      <div class="mb-8 flex justify-center">
        <div class="relative w-[480px]">
          <input
            v-model.trim="searchQuery"
             @keyup.enter="handleSearch"
            type="text"
            class="w-full rounded-lg border-none bg-white px-4 py-3 pl-12 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="搜索供应商..."
          />
        </div>
      </div>

      <!-- 卡片容器 -->
      <div class="grid grid-cols-5 gap-6">
        <article
          v-for="(card, index) in filteredCards"
          :key="card.name + index"
          class="group relative cursor-pointer overflow-hidden rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all duration-300 hover:shadow-md"
          :class="{ 'border-blue-500 ring-2 ring-blue-500': card.selected }"
          @click="toggleSelect(index,card.supply_id)"
        >
          <!-- 图片容器 -->
          <div class="relative mb-4 aspect-[4/3] w-full overflow-hidden rounded-lg">
            <img
              :src="card.image_url"
              :alt="card.name"
              class="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
            />
          </div>

          <!-- 卡片内容 -->
          <div class="mb-2 flex items-start justify-between">
            <h3 class="text-lg font-medium text-gray-900">{{ card.name }}</h3>
      
          </div>
          
          <p class="text-sm text-gray-600 line-clamp-3">{{ card.address }}</p>
          <p class="text-sm text-gray-600 line-clamp-3">  类型： {{ card.kmd_grade.name }}</p>
       
        </article>
      </div>
    </div>
  </div>
     
    </div>
  </el-dialog>
    
  </template>
  
  <script>

  import AuthApi from '@/api/auth.js';
  import SupplyApi from '@/api/supply.js';
  export default {
    components: {
       /*图片上传*/
   
    },
    data() {
      return {

        loading: false,
        dialogVisible:false,


        searchQuery: '',
       /*一页多少条*/
       pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {},
      tableData:[]
      };
    },
    created() {
      this.dialogVisible = this.open_add;
      this.getDetail();
  
    },
    props: ["open_add","shop_user_id"],
    computed: {
      filteredCards() {
        const query = this.searchQuery
        return this.tableData.filter(card => 
          [card.name, card.supply_id].some(text => 
            text.includes(query)
          )
        )
      }
    },
    methods: {
      toggleSelect(index,supply_id) {
        let self = this;
        this.tableData = this.tableData.map((card, i) => 
          i === index ? { ...card, selected: !card.selected } : card
        )
     
        let Params = {};
        Params.supply_id = supply_id;
        Params.shop_user_id = self.shop_user_id;
        self.loading = true;
        SupplyApi.setUserSupplyAuth(Params, true)
          .then(data => {
            self.loading = false;
            self.$message({
                message: '设置成功',
                type: 'success'
            });
          })
          .catch(error => {});

      },
      handleSearch() {
      if (this.searchQuery.trim()) {
        // 调用 API 或过滤数据
          this.getDetail();
      }
    },
        getDetail(){
              /*获取列表*/
 
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.name = self.searchQuery;
        Params.list_rows = 200;
        Params.kmd_grade_id = [10];
        Params.shop_user_id = self.shop_user_id;
        self.loading = true;
        SupplyApi.supplyList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {});

        },
    
       /*关闭弹窗*/
       dialogFormVisible(result) {
        this.$emit("close", {});
      },
      cancelFunc(){//取消
        this.dialogFormVisible("error")
      },
  
    }
  };
  </script>
  
  <style>

  /* 移除数字输入框的默认样式 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 添加文字截断样式 */
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  
  .ql-editor {
    height: 400px;
  }
  
  
  
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  
  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
  
  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }
  
  .draggable-list .item:hover .delete-btn {
    display: block;
  }
  
  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }
  
  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }
  
  .draggable-list .img-select i {
    color: #409eff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/auth/user/dialog/pfd.vue